<template>
  <div>
    <h2 class="section__title">{{ text }}</h2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/helpers'

export default {
  name: 'at-the-pharmacy',
  computed: {
    ...mapGetters(['orderData', 'dateToDeliver', 'timeToDeliver']),
    text() {
      let text = `${this.$t('main-page.delivering.not-confirmed.statuses.at-pharmacy')} `
      if (this.dateToDeliver) {
        text += this.dateToDeliver
      }

      if (this.timeToDeliver) {
        text += ` ${this.timeToDeliver}`
      }

      return text
    },
  },
}
</script>
